import { FDIcon, FDSecondaryActionButton } from '@facet-wealth/design';
import PlaidComponent from 'Components/UI/PlaidComponent';
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { AccountRefreshType } from './Consts';


export const InstitutionActionButton = (props) => {
  const {
    actionLinkRelationship,
    isDisabled,
    institutionResource,
    handleOnClick,
    onSyncComplete,
    onSyncStarted,
    onClose,
    source,
  } = props;

  const type = actionLinkRelationship.meta('type');
  const prompt = actionLinkRelationship.meta('prompt');

  const isPlaid = source === 'plaid';

  let BaseButton = (
    <FDSecondaryActionButton
      label={prompt}
      size={'sm'}
      loading={isDisabled}
      disabled={isDisabled}
      // For Plaid we don't need to explicitly handle onClick because we wrap the button with the plaid component and that handles the onclick
      onClick={type === AccountRefreshType.fix && isPlaid ? null : handleOnClick}
      icon={type === AccountRefreshType.fix ? 'warning' : 'refresh'}
      test={'institution-action-button'}
    />
  );

  if (type === AccountRefreshType.fix) {
    BaseButton = (
      <Button
        size="small"
        loading={isDisabled}
        disabled={isDisabled}
        onClick={isPlaid ? null : handleOnClick}
        variant="outlined"
        color="error"
        startIcon={<FDIcon icon="warning" color="error" />}
      >
        {prompt}
      </Button>
    );
  }

  // with plaid, we need to wrap the component with the plaid component
  if (type === AccountRefreshType.fix && isPlaid) {
    return (
      <PlaidComponent
        institutionResource={institutionResource}
        plaidLink={actionLinkRelationship.link('related')}
        onClick={handleOnClick}
        onSyncStarted={onSyncStarted}
        linkSuccessCallback={async () => {
          onClose();
          await onSyncComplete();
        }}
        onExit={onClose}
      >
        {BaseButton}
      </PlaidComponent>
    );
  }

  return BaseButton;
};


InstitutionActionButton.defaultProps = {
};

InstitutionActionButton.propTypes = {
  institutionResource: PropTypes.object.isRequired,
  actionLinkRelationship: PropTypes.object.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  onSyncStarted: PropTypes.func.isRequired,
  onSyncComplete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  source: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
};
